import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Icon from "metabase/components/Icon";
import { TreeNode } from "metabase/components/tree/TreeNode";
import Tooltip from "metabase/components/Tooltip";
import Link from "metabase/core/components/Link";
import { NAV_SIDEBAR_WIDTH } from "metabase/nav/constants";
import { color } from "metabase/lib/colors";
export const SidebarIcon = styled(Icon)`
  ${(props) => !props.color && css`
      color: ${props.isSelected ? color("brand") : color("brand-light")};
    `}
`;
SidebarIcon.defaultProps = {
  size: 14
};
export const ExpandToggleButton = styled(TreeNode.ExpandToggleButton)`
  padding: 4px 0 4px 2px;
  color: ${color("brand-light")};
`;
const activeColorCSS = css`
  color: ${color("brand")};
`;
function getTextColor(isSelected) {
  return isSelected ? color("brand") : color("white");
}
export const NodeRoot = styled(TreeNode.Root)`
  color: ${(props) => getTextColor(props.isSelected)};

  background-color: transparent;

  padding-left: ${(props) => props.depth}rem;
  border-radius: 4px;

  ${ExpandToggleButton} {
    ${(props) => props.isSelected && activeColorCSS}
  }

  &:hover {
    background-color: transparent;
    color: ${color("brand")};

    ${ExpandToggleButton} {
      color: ${color("brand")};
    }

    ${SidebarIcon} {
      ${(props) => props.hasDefaultIconStyle && activeColorCSS};
    }
  }
`;
NodeRoot.defaultProps = {
  hasDefaultIconStyle: true
};
export const CollectionNodeRoot = styled(NodeRoot)`
  ${(props) => props.hovered && css`
      color: ${color("text-white")};
      background-color: ${color("brand")};
    `}
`;
const itemContentStyle = css`
  display: flex;
  align-items: center;
  width: 100%;
  &:hover {
    color: ${color("brand")};
  }
`;
export const FullWidthButton = styled.button`
  cursor: pointer;
  ${itemContentStyle}

  ${TreeNode.NameContainer} {
    font-weight: 700;
    color: #949AAB;
    text-align: start;

    &:hover {
      color: ${color("brand")};
    }
  }
`;
export const FullWidthLink = styled(Link)`
  ${itemContentStyle}
`;
const ITEM_NAME_LENGTH_TOOLTIP_THRESHOLD = 35;
const ITEM_NAME_LABEL_WIDTH = Math.round(parseInt(NAV_SIDEBAR_WIDTH, 10) * 0.7);
const ItemName = styled(TreeNode.NameContainer)`
  width: ${ITEM_NAME_LABEL_WIDTH}px;
  padding: 6px 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export function NameContainer({ children: itemName }) {
  if (itemName.length >= ITEM_NAME_LENGTH_TOOLTIP_THRESHOLD) {
    return /* @__PURE__ */ _jsx(Tooltip, {
      tooltip: itemName,
      maxWidth: "none"
    }, /* @__PURE__ */ _jsx(ItemName, null, itemName));
  }
  return /* @__PURE__ */ _jsx(TreeNode.NameContainer, null, itemName);
}
